import { Dialog, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CloseIcon from "@material-ui/icons/Close";
import { Pagination } from "@material-ui/lab";
import sortImg from "assets/icons/sort-able-svg.svg";
import { Loader } from "components";
import AuthService from "Lib/API/Auth";
import { debounce } from "lodash";
import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useState } from 'react';
import { formatPhoneNumber } from 'react-phone-number-input';
import { Link } from "react-router-dom";
import "./index.scss";
import { Fonts, FontColors } from "theme/fontConfig";


const phoneTo = (phone) => {
  const phoneNumber = formatPhoneNumber(phone)?.replace(/[^0-9]/g, "");
  const link = `tel:${phoneNumber || ""}`;
  return link;
};


export const DirectoryTable = ({ sortCharged, filters, page, setPage,accountIdParams,filterFamilyHandler }) => {

  const isMobile = useMediaQuery("(max-width:600px)");
  const [selectedMember, setSelectedMember] = useState(null);
  const [directoryListData, setDirectoryListData] = useState([])
  const [count, setCount] = useState([])
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false)
  const token = localStorage.getItem('token');



  useEffect(() => {
    setPage(0);
  }, []);
  const getDirectoryList = async () => {
    setLoading(true);
    const payload = {
      sort: filters?.sort,
      search: filters?.search,
  
    }
    if(accountIdParams){
      payload.filter = {
        accountId: accountIdParams
      }
    }
    try {
      const res = await AuthService.getDirectoryList(
        token,
        page + 1,
        10,
        payload,
      );

      setDirectoryListData(res.payload.data);
      setCount(res?.payload?.pagination?.count);
    } catch (error) {
      if (error?.data?.message) enqueueSnackbar(error?.data?.message, {
        variant: "error",
      });

    } finally {
      setLoading(false);
    }
  };


  const debounceSearch = useCallback(
    debounce(() => {
      if (filters?.search) {
        getDirectoryList();
      }
    }, 100),
    [filters.search, filters, page]
  );
  useEffect(() => {
    if (filters?.search) {
      debounceSearch();
    } else {
      getDirectoryList();
    }
    return () => debounceSearch.cancel();
  }, [filters.search, filters, page, accountIdParams]);
  const handleClickMail = (address) => {
    window.open(`mailto:${address}`);
  };
  const pagination = directoryListData?.length !== 0 && (
    <div className="pagination-custom mt-2">
      <Pagination
        count={Math.ceil(count / 10)}
        color="primary"
        variant="outlined"
        page={page + 1}
        onChange={(event, value) => setPage(value - 1)}
      />
    </div>
  );

  const detailRows = selectedMember ? [
    { label: "Family Name", value: selectedMember.familyName },
    { label: "Mobile", value: formatPhoneNumber(selectedMember.mobileNumber), href: `tel:${selectedMember.mobileNumber}` },
    { label: "Home Phone", value: formatPhoneNumber(selectedMember.homeNumber), href: `tel:${selectedMember.homeNumber}` },
    { label: "Email", value: selectedMember.emailAddress, href: `mailto:${selectedMember.emailAddress}` },
    { label: "Address", value: selectedMember.address?.formattedAddress, href: selectedMember.address?.formattedAddress ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selectedMember.address.formattedAddress)}` : undefined },
  ] : [];

  const memberDialog = (
    <Dialog
      open={!!selectedMember}
      onClose={() => setSelectedMember(null)}
      fullWidth
      maxWidth="sm"
      className="directory-member-card"
      PaperProps={{ style: { borderRadius: 20, margin: 16, overflow: "hidden" } }}
    >
      {/* Coloured header banner */}
      <div style={{ background: "linear-gradient(135deg, #2555EF 0%, #4F78F5 100%)", padding: "20px 16px 18px", position: "relative" }}>
        <IconButton
          onClick={() => setSelectedMember(null)}
          size="small"
          style={{ position: "absolute", right: 12, top: 12, color: FontColors.WhiteAlpha80, background: "rgba(255,255,255,0.15)", borderRadius: 8 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <div style={{
          width: 60, height: 60, borderRadius: "50%",
          background: "rgba(255,255,255,0.25)",
          border: "2px solid rgba(255,255,255,0.5)",
          display: "flex", alignItems: "center", justifyContent: "center",
          ...Fonts.GeneralPageHeaderFont, color: FontColors.White, 
          marginBottom: 12,
        }}>
          {(selectedMember?.firstName?.[0] || "").toUpperCase()}
        </div>
        <div style={{ ...Fonts.GeneralHeaderFont, color: FontColors.White, lineHeight: 1.2 }}>
          {selectedMember?.firstName} {selectedMember?.lastName}
        </div>
        {selectedMember?.familyName && (
          <div
            onClick={() => { setSelectedMember(null); filterFamilyHandler(`/directory/?accountId=${selectedMember.accountId}`); }}
            style={{ fontFamily: Fonts.GeneralSmallBodyFont.fontFamily, fontSize: Fonts.GeneralSmallBodyFont.fontSize, color: FontColors.WhiteAlpha85, marginTop: 4, cursor: "pointer", textDecoration: "underline", display: "inline-block" }}
          >
            {selectedMember.familyName}
          </div>
        )}
      </div>
      {/* Detail rows */}
      <DialogContent style={{ padding: "0 16px 16px" }}>
        {detailRows.filter(({ value }) => value && String(value).trim()).map(({ label, value, href }, idx, arr) => (
          <div key={label} style={{ padding: idx === 0 ? "8px 0 10px" : "10px 0", borderBottom: idx < arr.length - 1 ? "1px solid #F1F5F9" : "none" }}>
            <div style={{ ...Fonts.GeneralSmallLabelFont, color: FontColors.Slate94A3B8, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 3 }}>
              {label}
            </div>
            {href ? (
              <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer"
                style={{ ...Fonts.GeneralLabelFont, color: FontColors.Blue2555EF, wordBreak: "break-all" }}>
                {value}
              </a>
            ) : (
              <div style={{ ...Fonts.GeneralLabelFont, color: FontColors.Slate0F172A, wordBreak: "break-word" }}>
                {value}
              </div>
            )}
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );

  if (isMobile) {
    return (
      <div className="w-100">
        {memberDialog}
        {loading ? (
          <div className="tran-loader"><Loader /></div>
        ) : (
          <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", overflow: "hidden" }}>
            {directoryListData?.length === 0 ? (
              <div className="record-text" style={{ padding: 16 }}>No record found</div>
            ) : directoryListData?.map((item, i) => (
              <div
                key={i}
                onClick={() => setSelectedMember(item)}
                style={{
                  padding: "12px 16px",
                  borderBottom: i < directoryListData.length - 1 ? "1px solid #F1F5F9" : "none",
                  cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8,
                }}
              >
                <div>
                  <div style={{ ...Fonts.GeneralLabelFont, color: FontColors.Slate0F172A, lineHeight: 1.3 }}>
                    {item.firstName} {item.lastName}
                  </div>
                  {item.familyName && (
                    <div style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, fontFamily: Fonts.GeneralCaptionFont.fontFamily, color: FontColors.Slate64748B, lineHeight: 1.3 }}>
                      {item.familyName}
                    </div>
                  )}
                </div>
                <span style={{ color: FontColors.Slate94A3B8, fontSize: Fonts.GeneralXLargeBodyFont.fontSize, lineHeight: 1, flexShrink: 0 }}>›</span>
              </div>
            ))}
          </div>
        )}
        {pagination}
      </div>
    );
  }

  return (
    <div className="w-100">
      {memberDialog}
      <div className={"family-table-container pl-7 pr-6 pt-3"}>
        <div className="home-table-container mt-0 no-box-shadow p-0" style={{ height: 'auto' }}>
          <TableContainer component={Paper} style={{ overflow: 'unset' }}>
            <Table>
              <TableHead className="charges-table">
                <TableRow>
                  <TableCell className="date-head">
                    FAMILY NAME
                  </TableCell>
                  <TableCell className="date-head" onClick={() => sortCharged("firstName")}>
                    FIRST NAME
                    <IconButton>
                      <img src={sortImg} alt="sort" />
                    </IconButton>
                  </TableCell>
                  <TableCell className="status-head" align="left" onClick={() => sortCharged("lastName")}>
                    LAST NAME
                    <IconButton>
                      <img src={sortImg} alt="sort" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="tran-table-body">
                {directoryListData?.length === 0 ? loading === true ? (<div className="tran-loader">
                  <Loader />
                </div>) : (<td colSpan={3}>
                  <div className="record-text">No record found</div>
                </td>) : (directoryListData && directoryListData?.map((item) => (
                  <TableRow
                    className="myexpendRow"
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedMember(item)}
                  >
                    <TableCell component="th" scope="row" className="exp-status-cell" align="left">
                      <span style={{ color: FontColors.Blue2555EF }}>{item?.familyName}</span>
                    </TableCell>
                    <TableCell component="th" scope="row" className="exp-status-cell" align="left">
                      {item?.firstName}
                    </TableCell>
                    <TableCell component="th" scope="row" className="exp-status-cell" align="left">
                      {item?.lastName}
                    </TableCell>
                  </TableRow>
                )))}
              </TableBody>
            </Table>
          </TableContainer>
          {pagination}
          {/* <>
              <div className="pagination-custom mt-2">
                <Pagination
                  count={Math.ceil(count / 10)}
                  color="primary"
                  variant="outlined"
                  onChange={(event, value) => {
                    setPage(value - 1);
                  }}
                />
              </div>
            </> */}

        </div>
      </div>
    </div>
  );
};

